// utils/auth.js

export const getStoredUser = () => {
    try {
      return JSON.parse(localStorage.getItem("avatarUser"));
    } catch {
      return null;
    }
  };
  
  export const getAccessToken = () => {
    const user = getStoredUser();
    return user?.access_token || null;
  };
  
  export const decodeToken = (token) => {
    try {
      if (!token) return null;
  
      const decoded = JSON.parse(atob(token.split(".")[1]));
      return decoded
    } catch (error) {
      console.error("Token decode failed:", error);
      return null;
    }
  };
  
  export const getUserRole = () => {
    const token = getAccessToken();
    const decoded = decodeToken(token);
    return decoded
  };
  
  export const isAuthenticated = () => {
    return !!getAccessToken();
  };